var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewSlide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "8px",
    viewBox: "0 0 18 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "new-slide") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-slide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    stroke: "#666666",
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,0.5 L5.5,7.5",
    id: "Line-2",
    stroke: "#666666",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,2.5 L11.5,5.5",
    id: "Line-3",
    stroke: "#4F5052",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,4 L13,4",
    id: "Line-3-Copy",
    stroke: "#4F5052",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,0 L6,0 L6,8 L1,8 C0.44771525,8 6.76353751e-17,7.55228475 0,7 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z",
    id: "Rectangle",
    fillOpacity: 0.5,
    fill: "#979797"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSlide);
export default __webpack_public_path__ + "static/media/new-slide.e707026ca71f04868060825ca4a4c9b0.svg";
export { ForwardRef as ReactComponent };